import { useEffect, useRef } from "react";

export default function CustomCursor() {
  const ref = useRef(null);
  useEffect(() => {
    if (window.matchMedia("(hover: none)").matches) return;
    const el = ref.current;
    let raf, x = -100, y = -100, cx = -100, cy = -100;
    const move = (e) => { x = e.clientX; y = e.clientY; };
    const over = (e) => {
      const hot = e.target.closest("button, a, [role=button], input, select, label");
      el.style.width = el.style.height = hot ? "28px" : "12px";
    };
    const loop = () => {
      cx += (x - cx) * 0.22; cy += (y - cy) * 0.22;
      el.style.transform = `translate(${cx}px, ${cy}px) translate(-50%, -50%)`;
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    raf = requestAnimationFrame(loop);
    return () => { window.removeEventListener("mousemove", move); window.removeEventListener("mouseover", over); cancelAnimationFrame(raf); };
  }, []);
  return <div ref={ref} className="custom-cursor" aria-hidden="true" />;
}
